/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react'
import { Navigation } from 'js/pages/Home/Navigation'
import PartnershipLogo from './PartnershipLogo'
import { homeImages } from 'js/imageSources'

interface BlogHeroProps {
  title?: string
  description?: string
  buttonLabel?: string
  url?: string
}

const BlogHero: React.FC<BlogHeroProps> = ({
  title,
  description,
  buttonLabel,
  url,
}) => {
  return (
    <header
      className="blog-hero"
      style={{
        backgroundImage: `url(${homeImages.heroImage.src})`,
      }}
    >
      <div style={styles.overlay} />
      <div style={styles.heroContainer}>
        <Navigation
          customLogo={<PartnershipLogo theme="dark" />}
          theme="dark"
          minimal={false}
        />
        <div className="blog-hero-content">
          <h1 style={styles.title}>{title}</h1>
          <p style={styles.desc}>{description}</p>
          <a className="blog-hero-button" href={url}>
            {buttonLabel}
          </a>
        </div>
      </div>
    </header>
  )
}

const styles = {
  overlay: {
    width: '100%',
    height: '100%',
    background: 'rgba(0,0,0,0.35)',
    position: 'absolute' as const,
    top: 0,
    left: 0,
  },
  heroContainer: {
    position: 'relative' as const,
    width: '100%',
  },
  title: {
    fontSize: 'var(--font-size-5xl)',
    fontWeight: 700,
    marginBottom: '0',
    lineHeight: 'var(--line-height-heading)',
  },
  desc: {
    fontSize: 'var(--font-size-xl)',
    color: '#fff',
    textShadow: '0 1px 2px rgba(0,0,0,0.15)',
    maxWidth: '30ch',
  },
}

export default BlogHero
